const buildAudioMuteIconUrl = ({
  isMuted,
  isMobile,
  isLight,
}: {
  isMuted: boolean
  isMobile: boolean
  isLight: boolean
}) => {
  const muteState = isMuted ? 'Mute' : 'Play-animated'
  const mobileOrDesktop = isMobile ? 'mobile' : 'desktop'
  const color = isLight ? 'light' : 'dark'
  return `https://assets.okapa.com/image/upload/v1678400809/revisedProductJourney2/iconography/${muteState}-${mobileOrDesktop}-${color}`
}

export default buildAudioMuteIconUrl
